/**
 * Onde os avisos visuais (toasts) aparecem na tela.
 * Preferência por dispositivo — cada operador escolhe o canto que preferir.
 */
const STORAGE_KEY = "notif.toast.position";
const DEFAULT_POSITION = "top-center";

export const TOAST_POSITIONS = [
  { id: "top-left", label: "Superior esquerdo" },
  { id: "top-center", label: "Superior central" },
  { id: "top-right", label: "Superior direito" },
  { id: "bottom-left", label: "Inferior esquerdo" },
  { id: "bottom-center", label: "Inferior central" },
  { id: "bottom-right", label: "Inferior direito" },
];

const listeners = new Set();
let position =
  (typeof window !== "undefined" && window.localStorage.getItem(STORAGE_KEY)) ||
  DEFAULT_POSITION;

if (!TOAST_POSITIONS.some((p) => p.id === position)) position = DEFAULT_POSITION;

export function getToastPosition() {
  return position;
}

export function setToastPosition(next) {
  if (!TOAST_POSITIONS.some((p) => p.id === next)) return;
  position = next;
  if (typeof window !== "undefined") window.localStorage.setItem(STORAGE_KEY, next);
  listeners.forEach((fn) => fn(position));
}

export function subscribeToastPosition(fn) {
  listeners.add(fn);
  fn(position);
  return () => listeners.delete(fn);
}
